module.exports = __webpack_public_path__ + "img/1.adcd8a52.png";